import MenuBucketNavSwitch from '@app/components/LoggedIn/Menu/common/NavSwitch';

const Categories = () => <MenuBucketNavSwitch bucket="categories" />;

export default Categories;
